import React, { useState, useEffect } from 'react';

export const RemainingCharacters = ({ maxNoCharacters, inputValue }) => {
    const [message, setMessage] = useState(null);
    
    useEffect(() => {
        const noOfRemainingChars = maxNoCharacters - inputValue.length;
        if (noOfRemainingChars >= 0) {
            setMessage(<p>{`You have ${noOfRemainingChars} characters remaining`}</p>);
          } else {
            const characterOutput = Math.abs(inputValue.length - maxNoCharacters) > 1 ? "characters" : "character"; 
            setMessage(<p className="text-danger">{`You have ${Math.abs(inputValue.length - maxNoCharacters)} ${characterOutput} too many`}</p>);
          }
    },[inputValue, maxNoCharacters])

    return (
      inputValue !== '' && message
    );
}
